import ItemThumbnailCarousel from './itemThumbnailCarousel'

export default ItemThumbnailCarousel
